import { CERT_EO_CAMPAIGN_ROW_TYPE } from '../../CertsDetailsList/Tile/constant';
import {
  CERT_ENTITLEMENT_VALUEKEY,
  CERTIFIED,
  EO_CERTIFIED,
} from '../constant';

import { ROLE_TYPES } from './constants';

export const getApprovePayload = (
  isEOCampaign,
  isApprove,
  certKey,
  nodeData,
  commentValue
) => {
  const accountKey = nodeData?.CERT_ACCOUNTKEY;
  const userKey = nodeData?.CERT_USERKEY;
  const entValueKey = nodeData?.CERT_ENTITLEMENT_VALUEKEY;

  if (isEOCampaign) {
    const approvePayload = {
      certKey,
      entValueKey,
      accountKey: accountKey?.toString(),
      status: isApprove ? EO_CERTIFIED.RESET : EO_CERTIFIED.APPROVE,
    };

    switch (nodeData?.ROW_TYPE?.toString()) {
      case CERT_EO_CAMPAIGN_ROW_TYPE.ENTITLEMENT:
        approvePayload.tabletoupdate = '0';
        break;
      case CERT_EO_CAMPAIGN_ROW_TYPE.ACCOUNT:
        approvePayload.tabletoupdate = '1';
        break;
      case CERT_EO_CAMPAIGN_ROW_TYPE.CHILD_ENTITLEMENT:
        approvePayload.cert_entitlement_value2key =
          nodeData?.CERT_ENTITLEMENT_VALUE2KEY?.toString();
        approvePayload.tabletoupdate = '2';
        break;
      default:
        break;
    }

    if (commentValue && commentValue.length > 0) {
      if (!isApprove) approvePayload.comment = commentValue;
    }

    if (isApprove) approvePayload.comment = 'Action Cancelled';

    return approvePayload;
  }

  const approvePayload = {
    certKey,
    userKey,
    entValueKey,
    accountKey,
    status: isApprove ? CERTIFIED.RESET : CERTIFIED.APPROVE,
    certRoleKey: nodeData?.CERT_ROLEKEY,
  };

  if (commentValue && commentValue.length > 0) {
    if (!isApprove) approvePayload.comment = commentValue;
  }

  if (isApprove) approvePayload.comment = 'Action Cancelled';

  return approvePayload;
};

export const getRejectPayload = (
  isEOCampaign,
  isReject,
  certKey,
  nodeData,
  commentValue
) => {
  const accountKey = nodeData?.CERT_ACCOUNTKEY;
  const userKey = nodeData?.CERT_USERKEY;
  const entValueKey = nodeData?.CERT_ENTITLEMENT_VALUEKEY;

  if (isEOCampaign) {
    const rejectPayload = {
      certKey,
      entValueKey,
      accountKey: accountKey?.toString(),
      status: isReject ? EO_CERTIFIED.RESET : EO_CERTIFIED.REVOKED,
    };

    switch (nodeData?.ROW_TYPE?.toString()) {
      case CERT_EO_CAMPAIGN_ROW_TYPE.ENTITLEMENT:
        rejectPayload.tabletoupdate = '0';
        break;
      case CERT_EO_CAMPAIGN_ROW_TYPE.ACCOUNT:
        rejectPayload.tabletoupdate = '1';
        break;
      case CERT_EO_CAMPAIGN_ROW_TYPE.CHILD_ENTITLEMENT:
        rejectPayload.cert_entitlement_value2key =
          nodeData?.CERT_ENTITLEMENT_VALUE2KEY?.toString();
        rejectPayload.tabletoupdate = '2';
        break;
      default:
        break;
    }

    if (commentValue && commentValue.length > 0) {
      if (!isReject) rejectPayload.comments = commentValue;
    }

    if (isReject) rejectPayload.comments = 'Action Cancelled';

    return rejectPayload;
  }

  let rejectPayload;

  if (entValueKey === CERT_ENTITLEMENT_VALUEKEY.ROLE) {
    rejectPayload = {
      eid: nodeData.id,
      certKey,
      userKey,
      entValueKey,
      certRoleKey: nodeData?.CERT_ROLEKEY,
      status: isReject ? CERTIFIED.RESET : CERTIFIED.REVOKED,
    };

    // for application role user and account auto approve - send account key as well in payload
    if (nodeData?.Role_ROLETYPE === ROLE_TYPES.APPLICATION_ROLE) {
      rejectPayload.accountKey = accountKey;
    }
  } else {
    rejectPayload = {
      eid: nodeData.id,
      accountKey,
      certKey,
      userKey,
      entValueKey,
      status: isReject ? CERTIFIED.RESET : CERTIFIED.REVOKED,
    };
  }

  if (commentValue && commentValue.length > 0) {
    if (!isReject) rejectPayload.comments = commentValue;
  }

  if (isReject) rejectPayload.comments = 'Action Cancelled';

  return rejectPayload;
};

export const getTerminateOrDecommissionPayload = (
  isEOCampaign,
  isTerminatedOrDecommission,
  certKey,
  nodeData,
  commentValue
) => {
  const accountKey = nodeData?.CERT_ACCOUNTKEY;
  const userKey = nodeData?.CERT_USERKEY;
  const entValueKey = nodeData?.CERT_ENTITLEMENT_VALUEKEY;

  if (isEOCampaign) {
    const payload = {
      certKey,
      status: isTerminatedOrDecommission
        ? EO_CERTIFIED.RESET
        : EO_CERTIFIED.DECOMMISSION,
      accountKey: accountKey || 0,
      entValueKey,
      tabletoupdate: '0',
    };

    if (commentValue && commentValue.length > 0) {
      if (!isTerminatedOrDecommission) payload.comments = commentValue;
    }

    if (isTerminatedOrDecommission) payload.comments = 'Action Cancelled';

    return payload;
  }

  const payload = {
    certKey,
    userKey,
    status: isTerminatedOrDecommission ? CERTIFIED.RESET : CERTIFIED.TERMINATED,
  };

  if (commentValue && commentValue.length > 0) {
    if (!isTerminatedOrDecommission) payload.comments = commentValue;
  }

  if (isTerminatedOrDecommission) payload.comments = 'Action Cancelled';

  return payload;
};

export const getConditionalCertifiyPayload = (
  isEOCampaign,
  isConditionalCertifiy,
  getDate,
  currentDate,
  certKey,
  nodeData,
  comment
) => {
  const accountKey = nodeData?.CERT_ACCOUNTKEY;
  const userKey = nodeData?.CERT_USERKEY;
  const entValueKey = nodeData?.CERT_ENTITLEMENT_VALUEKEY;

  if (isEOCampaign) {
    let payload = {};

    if (nodeData?.ROW_TYPE.toString() === CERT_EO_CAMPAIGN_ROW_TYPE.ACCOUNT) {
      payload = {
        cert_accountkey: accountKey?.toString(),
        certkey: certKey,
        cert_entitlement_valuekey: entValueKey,
        certified: isConditionalCertifiy
          ? `${EO_CERTIFIED.RESET}`
          : `${EO_CERTIFIED.CONDITIONAL_CERTIFIY}`,
        enddate: getDate && getDate.length > 0 ? getDate : currentDate,
        tabletoupdate: '1',
      };
    }

    if (comment && comment.length > 0) {
      if (!isConditionalCertifiy) payload.comments = comment;
    }

    if (isConditionalCertifiy) payload.comments = 'Action Cancelled';

    return payload;
  }

  let payload = {};

  if (entValueKey <= 0) {
    payload = {
      accountKey,
      certKey,
      userKey,
      entValueKey,
      certRoleKey: nodeData?.CERT_ROLEKEY,
      status: isConditionalCertifiy
        ? CERTIFIED.RESET
        : CERTIFIED.CONDITIONAL_CERTIFIY,
      extendedEndDate: getDate && getDate.length > 0 ? getDate : currentDate,
    };
  } else {
    payload = {
      accountKey,
      certKey,
      userKey,
      entValueKey,
      status: isConditionalCertifiy
        ? CERTIFIED.RESET
        : CERTIFIED.CONDITIONAL_CERTIFIY,
      extendedEndDate: getDate && getDate.length > 0 ? getDate : currentDate,
    };
  }

  if (comment && comment.length > 0) {
    if (!isConditionalCertifiy) payload.comments = comment;
  }

  if (isConditionalCertifiy) payload.comments = 'Action Cancelled';

  return payload;
};

export const getReassignPayload = (
  isEOCampaign,
  certKey,
  nodeData,
  reassignPayload,
  reassignConfigMap
) => {
  if (isEOCampaign) {
    const payload = {
      certkey: certKey,
      cert_entitlement_valuekey: nodeData.CERT_ENTITLEMENT_VALUEKEY,
    };

    if (reassignPayload?.commentValue) {
      payload.comments = reassignPayload?.commentValue;
    }

    switch (nodeData?.ROW_TYPE?.toString()) {
      case CERT_EO_CAMPAIGN_ROW_TYPE.ENTITLEMENT:
        if (
          reassignPayload?.selectedUser &&
          !reassignPayload?.isSkipCertifierChecked
        ) {
          payload.assignee = reassignPayload?.selectedUser?.value;
          payload.hasNewEntitlementOwnerSelected = 'yes';
        }

        payload.parentAction = '1';

        break;
      case CERT_EO_CAMPAIGN_ROW_TYPE.ACCOUNT:
        if (
          reassignPayload?.selectedUser &&
          !reassignPayload?.isSkipCertifierChecked
        ) {
          payload.assignee = reassignPayload?.selectedUser?.value;
          payload.hasNewManagerSelected = 'yes';
        }

        payload.cert_accountkey = nodeData?.CERT_ACCOUNTKEY;
        payload.elasticId = nodeData?.id;
        break;
      case CERT_EO_CAMPAIGN_ROW_TYPE.CHILD_ENTITLEMENT:
        if (
          reassignPayload?.selectedUser &&
          !reassignPayload?.isSkipCertifierChecked
        ) {
          payload.assignee = reassignPayload?.selectedUser?.value;
          payload.hasNewManagerSelected = 'yes';
        }

        payload.elasticId = nodeData?.id;
        payload.cert_entitlement_value2key =
          nodeData?.CERT_ENTITLEMENT_VALUE2KEY;
        break;
      default:
        break;
    }

    if (payload?.assignee === reassignConfigMap?.defaultReassignee) {
      // eslint-disable-next-line no-param-reassign
      delete payload.assignee;
      delete payload.hasNewManagerSelected;
      payload.useDefaultReassignee = '1';
    }

    return payload;
  }

  const payload = {
    certkey: certKey,
    cert_userkey: nodeData.CERT_USERKEY,
    cert_entitlement_valuekey: nodeData.CERT_ENTITLEMENT_VALUEKEY,
    requestOrigin: 'UI',
  };

  if (reassignPayload?.commentValue) {
    payload.comments = reassignPayload?.commentValue;
  }

  if (
    reassignPayload?.selectedUser &&
    !reassignPayload?.isSkipCertifierChecked
  ) {
    payload.assignee = reassignPayload?.selectedUser?.value;
  }

  // SA campaign Reassign skip certifier check status
  if (reassignPayload?.status) {
    payload.status = reassignPayload?.status;
  }

  // SA campaign Update Account owner check step1
  if (reassignPayload?.step1Reassign) {
    payload.step1Reassign = reassignPayload?.step1Reassign;
  }

  switch (nodeData?.CERT_ENTITLEMENT_VALUEKEY) {
    case CERT_ENTITLEMENT_VALUEKEY.ACCOUNT:
      payload.cert_rolekey = nodeData.CERT_ROLEKEY;
      // by default pass isIncludeAssociateChecked value as true
      payload.reassignAssociated = 'true';
      // reassignPayload.isIncludeAssociateChecked.toString(); remove code after beta release

      if (nodeData.CERT_ACCOUNTKEY)
        payload.cert_accountkey = nodeData.CERT_ACCOUNTKEY;

      break;
    case CERT_ENTITLEMENT_VALUEKEY.ROLE:
      payload.cert_rolekey = nodeData.CERT_ROLEKEY;

      if (reassignPayload?.isIncludeAssociateChecked)
        payload.reassignAssociated =
          reassignPayload.isIncludeAssociateChecked.toString();

      if (nodeData.CERT_ACCOUNTKEY)
        payload.cert_accountkey = nodeData.CERT_ACCOUNTKEY;

      break;
    case CERT_ENTITLEMENT_VALUEKEY.ENTITLEMENT:
    default:
      if (CERT_ENTITLEMENT_VALUEKEY.ENTITLEMENT >= 0)
        if (reassignPayload?.isIncludeAssociateChecked)
          payload.reassignAssociated =
            reassignPayload.isIncludeAssociateChecked.toString();

      if (nodeData.CERT_ACCOUNTKEY)
        payload.cert_accountkey = nodeData.CERT_ACCOUNTKEY;

      break;
  }

  return payload;
};

export const getConsultPayload = (
  isEOCampaign,
  certKey,
  nodeData,
  consultPayload
) => {
  if (isEOCampaign) {
    const payload = {
      certkey: certKey,
      cert_entitlement_valuekey: nodeData.CERT_ENTITLEMENT_VALUEKEY,
      requestOrigin: 'UI',
      eid: nodeData?.id,
    };

    if (consultPayload?.commentValue) {
      payload.comments = consultPayload?.commentValue;
    }

    if (
      consultPayload?.selectedUser &&
      consultPayload.selectedUser?.value !== consultPayload.defaultReassignee
    ) {
      payload.assignee = consultPayload?.selectedUser?.value;
    }

    switch (nodeData?.ROW_TYPE?.toString()) {
      case CERT_EO_CAMPAIGN_ROW_TYPE.ENTITLEMENT:
        break;
      case CERT_EO_CAMPAIGN_ROW_TYPE.ACCOUNT:
        payload.assigneeType = '1';
        payload.cert_accountkey = nodeData?.CERT_ACCOUNTKEY;
        break;
      case CERT_EO_CAMPAIGN_ROW_TYPE.CHILD_ENTITLEMENT:
        payload.cert_entitlement_value2key =
          nodeData?.CERT_ENTITLEMENT_VALUE2KEY;
        break;
      default:
        break;
    }

    return payload;
  }

  const payload = {
    eid: nodeData.id,
    certkey: certKey,
    cert_userkey: nodeData.CERT_USERKEY,
    cert_entitlement_valuekey: nodeData.CERT_ENTITLEMENT_VALUEKEY,
    requestOrigin: 'UI',
  };

  if (consultPayload?.commentValue) {
    payload.comments = consultPayload?.commentValue;
  }

  if (
    consultPayload?.selectedUser &&
    consultPayload.selectedUser?.value !== consultPayload.defaultReassignee
  ) {
    payload.assignee = consultPayload?.selectedUser?.value;
  }

  switch (nodeData?.CERT_ENTITLEMENT_VALUEKEY) {
    case CERT_ENTITLEMENT_VALUEKEY.USER:
      break;
    case CERT_ENTITLEMENT_VALUEKEY.ACCOUNT:
    case CERT_ENTITLEMENT_VALUEKEY.ROLE:
      if (
        nodeData?.CERT_ENTITLEMENT_VALUEKEY === CERT_ENTITLEMENT_VALUEKEY.ROLE
      ) {
        payload.cert_rolekey = nodeData.CERT_ROLEKEY; // not required in account level
      }

      if (consultPayload?.isIncludeAssociateChecked) {
        payload.reassignAssociated =
          consultPayload.isIncludeAssociateChecked.toString();
      }

      if (nodeData?.CERT_ACCOUNTKEY) {
        payload.cert_accountkey = nodeData.CERT_ACCOUNTKEY;
      }

      break;
    case CERT_ENTITLEMENT_VALUEKEY.ENTITLEMENT:
    default:
      if (CERT_ENTITLEMENT_VALUEKEY.ENTITLEMENT >= 0) {
        if (consultPayload?.isIncludeAssociateChecked) {
          payload.reassignAssociated =
            consultPayload.isIncludeAssociateChecked.toString();
        }
      }

      if (nodeData.CERT_ACCOUNTKEY) {
        payload.cert_accountkey = nodeData.CERT_ACCOUNTKEY;
      }

      break;
  }

  return payload;
};
